import React from 'react'

const ActivitiesPage: React.FC = () => {
    

    return (
        <></>
    )
}

export default ActivitiesPage
